import { render, staticRenderFns } from "./CollectSourceList.vue?vue&type=template&id=174110bc&scoped=true&"
import script from "./CollectSourceList.vue?vue&type=script&lang=js&"
export * from "./CollectSourceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174110bc",
  null
  
)

export default component.exports